import { AlertContainer } from '@/components/escript/onboarding/Onboarding.styles';
import type { PropsWithChildren } from 'react';

export function OnboardingAlert({ children }: PropsWithChildren) {
  if (!children) {
    return null;
  }

  return <AlertContainer data-testid="onboarding-layout__alert">{children}</AlertContainer>;
}
